import React, { Component } from "react";
import FourthPageComponents from "views/Pma/PmaEditor/FourthPageComponents";

class YETwoFirstLeft extends Component {
  render() {
    const {
      printVersion,
      fromEditor,
      version,
      agentData,
      hoData,
      currentArea,
      coverPageDetails,
      testimonials,
      handlePropertyHighlightDialog,
      propertyPhotoDetailsDTO,
      quarterlyAreaTable,
      bubbleBoxes,
      quadrantDetails,
      quadrantModalOpen,
      altAgentData,
      volunteerDetails,
      agentFocusInfoList,
      designDetailsInfoList,
      showAllEditButtons,
    } = this.props;
    const { mlsAreaID } = currentArea;
    const { listgenUserID } = agentData;
    let useBackpageBoxes = false;
    let propertyHighlightsTitle;
    let propertyHighlightsSubtitle;
    let propertyHighlightsFooterText1;
    let propertyHighlightsFooterText2;
    let isDemo;
    let photoFiltered = [];
    if (listgenUserID === "100030") {
      let losAltosProp = {
        address: "-",
        bedBaths: "3/3.5",
        brokerageName: "Sotheby's International Realty",
        coListingAgentFirstName: null,
        coListingAgentLastName: null,
        coListingAgents: null,
        daysOnMarket: "1",
        guestHouseBathsAndBeds: null,
        isAgentFiltered: false,
        listDate: "2025-04-17T13:48:25",
        listPrice: "2800000",
        listingAgentLicenseID: "02033961",
        listingAgentName: "Nate Randall",
        lotSizeSquareFt: "16655",
        originalListPrice: "2800000",
        photoURL:
          "https://d2onbxnrte2nim.cloudfront.net/Los+Altos.jpg",
        propertyType: "Single Family Home",
        saleDate: "2025-05-13T00:00:00",
        salePrice: "2600000",
        sellingAgentLicenseID: "",
        sellingAgentName: "",
        squareFeet: "3333",
        status: "Active",
        streetDirPrefix: "-",
        streetName: "Los Altos",
        streetNumber: "4071",
        streetSuffix: "Drive",
        unitNumber: "-",
        view: "NoViews",
      };
      let allPhotoDetails = [
        ...propertyPhotoDetailsDTO.buyerAgentPhotoDetails,
        ...propertyPhotoDetailsDTO.photoDetails,
        losAltosProp,
      ];
      photoFiltered = allPhotoDetails.filter(
        (x) =>
          x.streetName.includes("3rd") ||
          x.streetName.includes("Pico") ||
          x.streetName.includes("San Pedro") ||
          x.streetName.includes("Congress") ||
          x.streetNumber.includes("4071") ||
          x.streetName.includes("4th"),
      );
      photoFiltered.map((list) => {
        if (list.streetName === "NE of 4th on Lopez") {
          list.status = "Sold";
          list.salePrice = "3800000";
          list.daysOnMarket = "5";
          list.saleDate = "2025-06-13T00:00:00";
        } else {
          return list;
        }
      });
    }
    // Use agentSelectedPhotoDetails as the only source of selected/highlighted properties
    let agentSelectedPhotoDetails =
      propertyPhotoDetailsDTO &&
      propertyPhotoDetailsDTO.agentSelectedPhotoDetails
        ? propertyPhotoDetailsDTO.agentSelectedPhotoDetails
        : [];
    if (propertyPhotoDetailsDTO) {
      propertyHighlightsTitle = propertyPhotoDetailsDTO.propertyHighlightsTitle;
      propertyHighlightsSubtitle =
        propertyPhotoDetailsDTO.propertyHighlightsSubtitle;
      propertyHighlightsFooterText1 =
        propertyPhotoDetailsDTO.propertyHighlightsFooterText1;
      propertyHighlightsFooterText2 =
        propertyPhotoDetailsDTO.propertyHighlightsFooterText2;
    }
    let hasTitle =
      propertyHighlightsTitle && propertyHighlightsTitle.length > 1;
    let hasSubtitle =
      propertyHighlightsSubtitle && propertyHighlightsSubtitle.length > 1;
    let hasFooterText1 =
      propertyHighlightsFooterText1 && propertyHighlightsFooterText1.length > 1;
    let hasFooterText2 =
      propertyHighlightsFooterText2 && propertyHighlightsFooterText2.length > 1;
    if (listgenUserID === "105") {
      isDemo = true;
      hasTitle = true;
      propertyHighlightsTitle = "The magic of new beginnings";
      hasSubtitle = true;
      propertyHighlightsSubtitle =
        "A sampling of the beautiful homes I represented";
      hasFooterText1 = true;
      propertyHighlightsFooterText1 =
        "Contact me today for complimentary home valuation.";
      hasFooterText2 = true;
      propertyHighlightsFooterText2 = "415-256-7890";
    }
    let useQuadrants = false;
    if (
      !propertyPhotoDetailsDTO ||
      !agentSelectedPhotoDetails ||
      agentSelectedPhotoDetails.length === 0 ||
      listgenUserID === "104597" ||
      listgenUserID === "106591"
    ) {
      useQuadrants = true;
    } else if (mlsAreaID === "x") {
      useBackpageBoxes = true;
    }
    useQuadrants = true;

    return (
      <FourthPageComponents
        currentArea={currentArea}
        printVersion={printVersion}
        fromEditor={fromEditor}
        agentData={agentData}
        isDemo={isDemo}
        hoData={hoData}
        version={version}
        coverPageDetails={coverPageDetails}
        quadrantModalOpen={quadrantModalOpen}
        mlsAreaID={mlsAreaID}
        photoFiltered={photoFiltered}
        currentSoldListings={agentSelectedPhotoDetails}
        handlePropertyHighlightDialog={handlePropertyHighlightDialog}
        quarterlyAreaTable={quarterlyAreaTable}
        title={hasTitle ? propertyHighlightsTitle : ""}
        subtitle={hasSubtitle ? propertyHighlightsSubtitle : ""}
        footerText1={hasFooterText1 ? propertyHighlightsFooterText1 : ""}
        footerText2={hasFooterText2 ? propertyHighlightsFooterText2 : ""}
        quadrantDetails={quadrantDetails}
        agentFocusInfoList={agentFocusInfoList}
        designDetailsInfoList={designDetailsInfoList}
        testimonials={testimonials}
        bubbleBoxes={bubbleBoxes}
        sortSelected={agentSelectedPhotoDetails}
        hasTitle={hasTitle}
        propertyHighlightsTitle={propertyHighlightsTitle}
        hasSubtitle={hasSubtitle}
        propertyHighlightsSubtitle={propertyHighlightsSubtitle}
        hasFooterText1={hasFooterText1}
        propertyHighlightsFooterText1={propertyHighlightsFooterText1}
        hasFooterText2={hasFooterText2}
        propertyHighlightsFooterText2={propertyHighlightsFooterText2}
        useQuadrants={useQuadrants}
        useBackpageBoxes={useBackpageBoxes}
        propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
        altAgentData={altAgentData}
        volunteerDetails={volunteerDetails}
        showAllEditButtons={showAllEditButtons}
      />
    );
  }
}

export default YETwoFirstLeft;
